import { WorldpayCustomisationInteraction } from '../../models/worldpay/worldpay-customisation-interaction.interface';
import { mockWorldpayCustomisationBorder } from './worldpay-customisation-border.mock';

export const mockWorldpayCustomisationInteraction: WorldpayCustomisationInteraction =
  {
    backgroundColor: '#000000',
    border: mockWorldpayCustomisationBorder,
    color: '#000000',
    fonts: [],
  };
